export default function formatPercent(
  amount: number | null | undefined,
  fractionDigits = 2
) {
  const defaultValue = amount ?? 0;
  return `${defaultValue.toFixed(fractionDigits).replace('.', ',')} %`;
}
